import React, {useEffect, useState} from 'react';
import {jwtDecode} from 'jwt-decode';
import { Navigate } from 'react-router-dom';
import { validateToken } from '../helpers/auth';

export default function PrivateRoute({children}){
    const authToken = localStorage.getItem('token');
    const [isTokenValid, setIsTokenValid] = useState(null);

    useEffect(() => {
        
        const checkTokenValidity = async () => {
            if (!authToken) {
                console.log("NO TOKEN")
                setIsTokenValid(false);
                return;
            }

            try {
                // First, validate JWT structure and expiry
                const decodedToken = jwtDecode(authToken);
                
                // Check if token is expired
                if (decodedToken.exp * 1000 < Date.now()) {
                    console.log('Token expired. Logging out...');
                    localStorage.removeItem('token');
                    setIsTokenValid(false);
                    return;
                }

                // JWT is valid, allow access immediately
                // Database validation can happen in background (optional check)
                setIsTokenValid(true);

                // Optionally validate with database in background (non-blocking)
                // Add timeout to prevent hanging
                const validationPromise = validateToken(authToken);
                const timeoutPromise = new Promise((resolve) => 
                    setTimeout(() => resolve(false), 2000) // 2 second timeout
                );

                try {
                    const isValid = await Promise.race([validationPromise, timeoutPromise]);
                    // Only update if database validation fails (and we got a response)
                    if (isValid === false && typeof isValid === 'boolean') {
                        console.warn('Database token validation failed, but JWT is valid');
                        // Don't remove token if JWT is valid - JWT validation is sufficient
                    }
                } catch (validationError) {
                    console.warn('Token validation error (non-critical):', validationError);
                    // Don't fail auth if database check fails - JWT is already validated
                }

            } catch (error) {
                console.error('Error decoding token:', error);
                // Only remove token if JWT decode fails (invalid token structure)
                localStorage.removeItem('token');
                setIsTokenValid(false);
            }
        };

        checkTokenValidity();
    }, [authToken]);

    if (isTokenValid === null) {
        return <div>Loading...</div>; // You can replace this with a proper loading spinner
    }

    return isTokenValid ? children : <Navigate to="/login" />;

}